import styled from 'styled-components/macro'
import { themeGet } from '@styled-system/theme-get'
import { CloseSVG } from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import { FlexColumn, FlexRow } from 'src/components/Reusable/Flex'

export const FrameworkActionButton = styled.button`
  background: transparent;
  border: none;
  color: ${palette.blue[500]};
  cursor: pointer;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.04em;
  padding: 0;
  text-transform: uppercase;

  &:disabled {
    color: ${palette.neutral[400]};
    cursor: not-allowed;
  }
`

export const FrameworkActionPipe = styled.span`
  color: ${palette.blue[500]};
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 500;
`

export const EditorContainer = styled(FlexColumn)`
  width: 100%;
  gap: 16px;
  align-items: stretch;
`

export const SectionsList = styled(FlexColumn)`
  width: 100%;
  gap: 12px;
  align-items: stretch;
`

export const SectionCard = styled.div`
  width: 100%;
  border: 1px solid ${themeGet('colors.border.neutral.light')};
  border-radius: 12px;
  background-color: ${themeGet('colors.bg.neutral')};
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SectionHeaderRow = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export const SectionHeaderTitle = styled.p`
  margin: 0;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 600;
  color: ${themeGet('colors.text.default')};
`

export const RemoveIconButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${palette.neutral[600]};
  cursor: pointer;
  display: inline-flex;
  height: 24px;
  justify-content: center;
  padding: 0;
  width: 24px;

  &:hover {
    color: ${palette.neutral[900]};
  }
`

export const RemoveIcon = styled(CloseSVG)`
  height: 12px;
  width: 12px;
  path {
    fill: currentColor;
  }
`

export const SectionFieldLabel = styled.label`
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  color: ${themeGet('colors.text.default')};
  margin: 0 0 4px 0;
`

export const RequirementsList = styled(FlexColumn)`
  width: 100%;
  gap: 8px;
  align-items: stretch;
`

export const RequirementRow = styled.div`
  width: 100%;
  border: 1px solid ${themeGet('colors.border.neutral.light')};
  border-radius: 8px;
  background-color: ${themeGet('colors.bg.neutral')};
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const RequirementRowHeader = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export const RequirementRowTitle = styled.p`
  margin: 0;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 600;
  color: ${themeGet('colors.text.default')};
`

export const NameAndControlsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: start;
  width: 100%;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const FieldColumn = styled(FlexColumn)`
  min-width: 0;
  width: 100%;
  gap: 4px;
  align-items: stretch;
`

/**
 * Compact wrapper around `NewMarkdownEditor` to enforce a short default height
 * and let overflow scroll inside the editor rather than expanding the modal.
 */
export const CompactMarkdown = styled.div`
  width: 100%;

  .mde-text {
    min-height: 80px;
    max-height: 80px;
    overflow-y: auto;
  }

  .mde-preview .mde-preview-content {
    min-height: 80px;
    max-height: 140px;
    overflow-y: auto;
  }
`

export const AddButtonRow = styled(FlexRow)`
  width: 100%;
  justify-content: flex-start;
  padding: 4px 0;
`
